import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../redux/selector';

const PrivateRoute = ({ children }) => {
    const isAuthenticated = useSelector((state) => state.isAuthenticated);
    const user = useSelector(selectUser);
    const location = useLocation();

    if (isAuthenticated) {
        if (user && user.isNewUser && location.pathname !== '/change-password') {
            return <Navigate to="/change-password" replace />;
        }
        return children;
    } else {
        return <Navigate to="/login" replace />;
    }
}

export default PrivateRoute;
